import React, { useEffect, useState } from "react";
import { Card, Table } from "antd";
import MgmtLayout from "../../../components/layouts/MgmtLayout";
import MgmtService from "../../../app/service/mgmtService";
import { Link } from "react-router-dom";
import { Button } from "../../../components";

export const MgmtClients = () => {
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(false);

    const mgmtService = new MgmtService();

    const columns = [
        {
            title: () => {
                return <div style={{ display: 'flex', color: 'white', fontSize: '14px', fontWeight: 500, justifyContent: 'center' }}>Nome</div>
            },
            align: 'center',
            dataIndex: 'name',
            key: 'name',
            size: 80
        },
        {
            title: () => {
                return <div style={{ display: 'flex', color: 'white', fontSize: '14px', fontWeight: 500, justifyContent: 'center' }}>API Username</div>
            },
            align: 'center',
            dataIndex: 'apiUsername',
            key: 'apiUsername',
            size: 80
        },
        {
            title: () => {
                return <div style={{ display: 'flex', color: 'white', fontSize: '14px', fontWeight: 500, justifyContent: 'center' }}>API Password</div>
            },
            align: 'center',
            dataIndex: 'apiPassword',
            key: 'apiPassword',
            size: 80
        },
        {
            title: () => {
                return <div style={{ display: 'flex', color: 'white', fontSize: '14px', fontWeight: 500, justifyContent: 'center' }}>Key Suntech</div>
            },
            align: 'center',
            dataIndex: 'keySuntech',
            key: 'keySuntech',
            size: 80
        },
        {
            title: () => {
                return <div style={{ display: 'flex', color: 'white', fontSize: '14px', fontWeight: 500, justifyContent: 'center' }}>Token Telegram</div>
            },
            align: 'center',
            dataIndex: 'telegramToken',
            key: 'telegramToken',
            size: 80
        },
    ]

    useEffect(() => {
        setLoading(true);

        mgmtService.getClients().then(res => {
            setClients(res.data.data);
            setLoading(false);
        }).catch(err => {
            setLoading(false);
        });
    }, []);

    return (
        <MgmtLayout>
            <Card title='Clientes'>
                <Link to='/mgmt/client/create'><Button style={{ marginBottom: '15px' }}>+ Novo</Button></Link>

                <Table
                    size='small'
                    scroll={{ x: 240, y: 240 }}
                    style={{ width: '100%', overflow: 'hidden' }}
                    columns={columns}
                    dataSource={clients}
                    loading={loading}
                />
            </Card>
        </MgmtLayout>
    );
}